import { useEffect, useState } from 'react';
import axios from 'src/utils/axios';
import { baseURLStaging } from 'src/config-global';
import GanttView from './Gantt';
import { LoadingScreen } from '../loading-screen';
import './Gantt.css'
import { getData } from './tasks';
import { useData } from 'src/contexts/gantt-chart/gantt-context';

const MainGantt = () => {
  const { data, loading, refreshData } = useData();
  const [isFirstTime,setIsFirstTime]=useState(true)

  useEffect(() => {
    refreshData()
  }, []);
  useEffect(() => {
    if (!loading) {
      setIsFirstTime(false);
    }
  }, [loading]);
  if (loading && isFirstTime) {
    return <LoadingScreen/>;
  }

  // if (!gantdata) {
  //   return <div>No data available.</div>;
  // }
  let gantData2=getData()

  return (
    <GanttView gantt_resources={data} relaod={() => refreshData()} />
  );
};

export default MainGantt;
